import axios from "axios";

const BASE = process.env.REACT_APP_HAMTA_API;

if (!BASE) {
  // eslint-disable-next-line no-console
  console.error("REACT_APP_HAMTA_API is not set — API calls will hit the wrong origin.");
}

const client = axios.create({ baseURL: BASE, timeout: 20000 });

export const fileUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  return `${BASE}/files/${path}`;
};

export const api = {
  getStores: () => client.get("/stores").then((r) => r.data),
  getStoreProducts: () => client.get("/store-products").then((r) => r.data),
  getSectionProducts: (storeId) => client.get("/store-products", { params: { store_id: storeId, limit: 5000 } }).then((r) => r.data),
  createOrder: (payload) => client.post("/orders", payload).then((r) => r.data),
  getOrder: (id) => client.get(`/orders/${id}`).then((r) => r.data),
  checkout: (id, body) => client.post(`/orders/${id}/checkout`, body).then((r) => r.data),
  paymentStatus: (id, guestId) =>
    client.get(`/orders/${id}/payment-status`, { params: { guest_id: guestId } }).then((r) => r.data),
  sendChat: (payload) => client.post("/chat/messages", payload).then((r) => r.data),
  getChat: (params) => client.get("/chat/messages", { params }).then((r) => r.data),
  unread: (params) => client.get("/chat/unread", { params }).then((r) => r.data),
};

export default api;
